import useConversation from 'app/modules/live-chat/hooks/useConversation';
import { getOstroWS } from 'app/services/ostroWS';
import { useEffect } from 'react';
import { WebsocketEvent } from 'websocket-ts';
import { useLocation } from 'react-router-dom';

import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export const ActiveScreen: Record<string, string> = {
  '/tailor': 'help_center',
  '/tailor/search': 'tailor_search',
  '/tailor/article': 'tailor_page',
  '/virtual-assistant': 'virtual_assistant',
  '/tailor/info/terms': 'terms_of_use',
  '/tailor/info/privacy': 'privacy_policy',
  '/tailor/info/isi': 'other',
  '/live-chat': 'live_chat',
} as const;

const ONLINE_CHECK_INTERVAL = 3000;

export default function useOstroWS() {
  const conversation = useConversation();
  const { data } = useFetchHelpCenter();
  const ostroWS = getOstroWS();
  const location = useLocation();

  useEffect(() => {
    if (!data?.uuid) return;

    const handleConnect = () => {
      ostroWS.send(
        JSON.stringify({
          action: 'intake_auth',
          web_chat_uuid: data.uuid,
        })
      );
    };

    ostroWS.addEventListener(WebsocketEvent.open, handleConnect);

    return () => {
      ostroWS.removeEventListener(WebsocketEvent.open, handleConnect);
    };
  }, [data?.uuid, ostroWS]);

  useEffect(() => {
    if (!conversation) return;

    const intId = setInterval(() => {
      ostroWS.send(
        JSON.stringify({
          action: 'web_conversation_user_online',
          conversation_sid: conversation.sid,
          source: 'web_conversation',
        })
      );
    }, ONLINE_CHECK_INTERVAL);

    return () => clearInterval(intId);
  }, [conversation, ostroWS]);

  useEffect(() => {
    if (!data?.uuid) return;

    const active_chat_screen = ActiveScreen[location.pathname] || 'other';

    ostroWS?.send(
      JSON.stringify({
        action: 'web_conversation_active_screen',
        active_chat_screen,
        conversation_uuid: data?.uuid,
      })
    );
  }, [data?.uuid, ostroWS, location]);
}
